import Typography from "ds/components/Typography";

import ChangeHistoryCardValueBadge from "./ValueBadge";

type ChangeHistoryCardVersionBadgesProps = {
  from: string;
  to: string;
};

const ChangeHistoryCardVersionBadges = ({ from, to }: ChangeHistoryCardVersionBadgesProps) => (
  <>
    <Typography tag="span" variant="p-t7">
      Version
    </Typography>
    <ChangeHistoryCardValueBadge variant="yellow" text={from} />
    <Typography tag="span" variant="p-body3" color="secondary">
      changed to
    </Typography>
    <ChangeHistoryCardValueBadge variant="yellow" text={to} />
  </>
);

export default ChangeHistoryCardVersionBadges;
